var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infoPanelThree",class:{infoPanelThree3:_vm.type == 'max'}},[_c('div',{staticClass:"panelTitle"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"panelCount",style:({'color':_vm.Color})},[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []

export { render, staticRenderFns }